import "./CSS/PlaygroundAnimation.css"

const PlaygroundAnimation = () => {
    return (
        <div className="code-editor">
            <div className="heading">Code Playground</div>
            <div className="section-one">
                <div className="line one s1l1"></div>
                <div className="line two s1l2"></div>
                <div className="line three s1l3"></div>
            </div>
            
                <div className="section-two">
                <div className="line four s2l1"></div>
                <div className="line two s2l2"></div>
                <div className="line one s2l3"></div>
                <div className="line three s2l4"></div>
                <div className="line one s2l5"></div>
            </div>
            
                
                <div className="section-three">
                <div className="line four s3l1"></div>
                <div className="line two s3l2"></div>
                <div className="line three s3l3"></div>
                <div className="line one s3l4"></div>
            </div>
        </div>
    )
}

export default PlaygroundAnimation
